import React from "react";
import VerifyMobileEmail from "../VerifyMobileEmail";

const ContactVerificationSection = ({
  formValues,
  setFormValues,
  formErrors,
  setFormErrors,
  onChangeInput,
  userInfoData,
}) => {
  return (
    <div className="staff-onboarding-form-section">
      <div className="staff-onboarding-section-header">
        <h3 className="staff-onboarding-section-title">Contact Verification</h3>
        <p className="staff-onboarding-section-subtitle">
          Verify mobile and email before proceeding
        </p>
      </div>

      <div className="staff-onboarding-section-content flexBetween">
        <VerifyMobileEmail
          formValues={formValues}
          setFormValues={setFormValues}
          formErrors={formErrors}
          setFormErrors={setFormErrors}
          onChangeInput={onChangeInput}
          userInfoData={userInfoData}
        />
      </div>
    </div>
  );
};

export default ContactVerificationSection;
